import { config } from '../../config/config';
import { API_GATEWAY_URL, ETRF_MGMT_V2_PATH, ORDER_MGMT_V2_PATH } from '../../config';

export const apiOrdersPath = `${config()[API_GATEWAY_URL]}${config()[ORDER_MGMT_V2_PATH]}`;
export const etrfOrdersPath = `${config()[API_GATEWAY_URL]}${config()[ETRF_MGMT_V2_PATH]}`;
